// endpoints.ts
// List of generic fetch functions
import { fetchBackend as fetch } from "@/core/apis/backend"
import { EntityWithId } from "@/core/factory/types"

export function createEntityEndpoints(entityName: string) {
  const pluralize = (name: string) => (name.endsWith("y") ? name.slice(0, -1) + "ies" : name + "s")
  const plural = pluralize(entityName)

  return {
    fetch: async (route?: string) => {
      const url = route ? `/${plural}/${route}` : `/${plural}`
      return await fetch({ url })
    },
    create: async (data: EntityWithId) => await fetch({ url: `/${entityName}`, method: "POST", data }),
    patch: async (data: EntityWithId[]) => await fetch({ url: `/${plural}`, method: "PATCH", data }),
    update: async (data: EntityWithId) => await fetch({ url: `/${entityName}/${data.id}`, method: "PUT", data }),
    remove: async (id: string) => await fetch({ url: `/${entityName}/${id}`, method: "DELETE" })
  }
}
